import { register } from "async-ops";
import { getDefaultOptions } from "../../../../utils/fetch";
import { callMvcApi } from "../../../../call-web-api";
export const GET_POLICIES = "GET_POLICIES";

export const service = async (data) => {
  const options: object = {
    url: `/Api/PolicySearch/GetPolicies`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_POLICIES, service, mock);
